export const emailActionType = Object.freeze({
  0: "Email Confirmation",
  2: "Email Cancellation",
  4: "Email Reminder",
  6: "Email Reschedule",
});
export const smsActionType = Object.freeze({
  1: "SMS Confirmation",
  3: "SMS Cancellation",
  5: "SMS Reminder",
  7: "SMS Reschedule",
});
